import React, { useEffect, useState } from 'react';
import { Search, ArrowUpRight } from 'lucide-react';
import { CertificateStatus } from '../../types';
import { fetchDashboardSummary } from "../../services/dashboardService";


export const DashboardHome: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [metrics, setMetrics] = useState<any>(null);
  const [recentActivity, setRecentActivity] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

    // Mock Data
    const stats = {
        verified: 1250,
        students: 3200
    };

    // const recentActivity = [
    //     // { name: 'Anna Mitchell', course: 'Full Stack Web Development', date: '2025-04-15', status: CertificateStatus.VALID },
    //     // { name: 'John Doe', course: 'Cybersecurity', date: '2025-04-16', status: CertificateStatus.VALID },
    //     // { name: 'Jane Smith', course: 'Data Analytics', date: '2025-04-16', status: CertificateStatus.VALID },
    //     // { name: 'Duke Peter', course: 'Multimedia', date: '2025-04-13', status: CertificateStatus.VALID },
    //     // { name: 'Sarah Connor', course: 'Cloud Computing', date: '2025-04-12', status: CertificateStatus.VALID },
    // ];

    // const filteredActivity = recentActivity.filter(activity => 
    //     activity.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //     activity.course.toLowerCase().includes(searchQuery.toLowerCase())
    // );
  useEffect(() => {
    const loadDashboard = async () => {
      try {
        const data = await fetchDashboardSummary();

        setMetrics(data?.metrics || {});
        setRecentActivity(Array.isArray(data?.recent_verifications) ? data.recent_verifications : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadDashboard();
  }, []);

  const filteredActivity = recentActivity.filter((row: any) => {
    const q = (searchQuery || '').toLowerCase();
    const name = String(row?.student_name ?? row?.name ?? '').toLowerCase();
    const course = String(row?.course_name ?? row?.course ?? '').toLowerCase();
    return name.includes(q) || course.includes(q);
  });

  if (loading) {
    return (
      <div className="text-center py-20 text-gray-600 dark:text-gray-300">
        Loading dashboard...
      </div>
    );
  }

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      
      {/* Search Bar specific to Dashboard */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          <div className="max-w-lg w-full">
             <div className="text-gray-700 dark:text-gray-300 text-sm mb-2 font-medium"></div>
          </div>
          <div className="relative w-full md:w-auto">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 dark:text-gray-400 w-4 h-4" />
              <input 
                type="text" 
                placeholder="Search for certification, courses, students" 
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm w-full md:w-80 focus:ring-primary focus:border-primary text-gray-800 dark:text-white bg-white dark:bg-gray-700 placeholder-gray-500 dark:placeholder-gray-400 transition-colors"
              />
          </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white dark:bg-gray-800 p-6 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm flex flex-col justify-between h-40 hover:shadow-md transition-all">
            <h3 className="text-gray-600 dark:text-gray-400 font-semibold text-sm uppercase tracking-wide">Total Verified Certificates</h3>
            <div className="flex justify-between items-end">
                <span className="text-4xl font-bold text-gray-900 dark:text-white">{metrics?.total_verified_certificates?.toLocaleString()}</span>
                <div className="w-10 h-10 rounded-full bg-indigo-50 dark:bg-indigo-900/30 flex items-center justify-center text-primary dark:text-indigo-400">
                    <ArrowUpRight className="w-6 h-6" />
                </div>
            </div>
        </div>
        <div className="bg-white dark:bg-gray-800 p-6 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm flex flex-col justify-between h-40 hover:shadow-md transition-all">
            <h3 className="text-gray-600 dark:text-gray-400 font-semibold text-sm uppercase tracking-wide">Total Students</h3>
            <div className="flex justify-between items-end">
                <span className="text-4xl font-bold text-gray-900 dark:text-white">{metrics?.total_students?.toLocaleString()}</span>
                <div className="w-10 h-10 rounded-full bg-indigo-50 dark:bg-indigo-900/30 flex items-center justify-center text-primary dark:text-indigo-400">
                    <ArrowUpRight className="w-6 h-6" />
                </div>
            </div>
        </div>
      </div>

      {/* Recent Activity Table */}
      <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-sm overflow-hidden transition-colors">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
            <h3 className="text-lg font-bold text-gray-800 dark:text-white">Recently Verified Certificates</h3>
        </div>
        <div className="overflow-x-auto">
            <table className="w-full text-left text-sm text-gray-700 dark:text-gray-300 min-w-[600px]">
                <thead className="bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 uppercase text-xs font-semibold">
                    <tr>
                        <th className="px-6 py-3">Name</th>
                        <th className="px-6 py-3">Course</th>
                        <th className="px-6 py-3">Date Verified</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
                    {filteredActivity.length > 0 ? (
                        filteredActivity.map((row: any, index: number) => (
                          <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">{row?.student_name ?? row?.name ?? ''}</td>
                                <td className="px-6 py-4 text-gray-700 dark:text-gray-300">{row?.course_name ?? row?.course ?? ''}</td>
                                <td className="px-6 py-4 text-gray-700 dark:text-gray-300">{row?.date_verified ?? row?.date ?? ''}</td>
                          </tr>
                        ))
                    ) : (
                         <tr>
                            <td colSpan={3} className="px-6 py-8 text-center text-gray-600 dark:text-gray-400 font-medium">
                                No activity found matching "{searchQuery}"
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
      </div>
    </div>
  );
};
